import type { Recommendation } from '@shared/dream-components';
import toast from 'react-hot-toast';

import useEmail from '~/hooks/useEmail';

interface Props {
  recommendations: Recommendation[];
  fetcher: any;
  nextPage: () => void;
}

interface ReturnProps {
  handleSubmit: (formData: FormData, email?: string) => boolean;
}

const useFormSubmit = ({ recommendations, fetcher, nextPage }: Props): ReturnProps => {
  const [, setEmail] = useEmail();

  const handleSubmit = (formData: FormData, email?: string) => {
    if (recommendations.length === 0) {
      nextPage();
      return false;
    }

    const trimmedEmail = (email || formData.get('email') || '')?.toString().trim();
    formData.set('is_js_enabled', 'true');
    formData.set('email', trimmedEmail);

    // We get a lot of headless bots that submit empty emails. This will remove those from actual submissions and processed sentry errors.
    if (!trimmedEmail) {
      toast.error('Please enter a valid email address');
      return false;
    }

    // Update Email in local storage
    setEmail(trimmedEmail);

    fetcher.submit(formData, {
      method: 'post',
      action: '/recommendations_subscribe_form',
    });

    return true;
  };

  return {
    handleSubmit,
  };
};

export default useFormSubmit;
